import React, { useState } from "react"
import { setOutSideFormField } from './Helper'

interface Props {
  name: string,
  tag: string,
  content: string | null,
  labelName: string,
  iconClass: string,
  note: string,
}

const gon = (window as any).gon;
const otherThinkingUrl = gon.otherThinkingUrl
const coachTalkingUrl = gon.coachTalkingUrl

const InputField: React.FC<Props> = (props) => {
  const [content, setContent] = useState(props.content !== null ? props.content : "");

  const handleChange = (event: React.SyntheticEvent) => {
    const target = event.target as HTMLInputElement;
    setContent(target.value);
    setOutSideFormField(props.tag, target.value);
  }

  return (
    <div className="column-form">
      <div className="column-form-icon">
        <span className={props.iconClass + ' column-data-icon'}></span>
        <span className="column-data-icontext">{props.name}</span>
      </div>
      <div className="form-group">
        <label>{props.labelName}</label>
        { props.name === "別の考え" &&
          <label>
            <label style={{ paddingLeft : 20 }}><a href={otherThinkingUrl}>別の考えとは？</a></label>
            <label style={{ paddingLeft : 20 }}><a href={coachTalkingUrl}>コーチに相談する</a></label>
          </label>
        }
        <textarea className="form-control" value={content} onChange={handleChange} />
        <div className="small text-muted">{props.note}</div>
      </div>
    </div>
  )
}

export default InputField